import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Box, Text } from "@chakra-ui/react";
import {
  ContentState,
  convertFromHTML,
  convertToRaw,
  EditorState,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import { updateFormConfig } from "../../../../redux/actions/formConfigActions";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
class MessageBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML(props.messageBody))
      ),
      contentAsHtml: "",
    };
  }
  convertContentToHTML = (editorState) => {
    const currentContentAsHTML = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    return currentContentAsHTML;
  };
  onEditorStateChange = (editorState) => {
    const convertedContentAsHtml = this.convertContentToHTML(editorState);
    console.log(convertedContentAsHtml);
    this.setState((state) => ({
      ...state,
      editorState,
      contentAsHtml: convertedContentAsHtml,
    }));
    this.props.dispatchUpdateFormConfig({
      messageBody: convertedContentAsHtml,
    });
  };

  render() {
    const { editorState } = this.state;
    return (
      <Box mt="12px" w="583px" h="200" className="form-config__body">
        <Text fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Message
        </Text>
        <Box w="583px" h="176px">
          <Editor
            editorState={editorState}
            wrapperClassName="demo-wrapper"
            editorClassName="demo-editor"
            onEditorStateChange={this.onEditorStateChange}
            toolbar={{
              options: ["inline", "list", "textAlign", "link", "history"],
            }}
            defaultContentState="createWithContent"
          />
        </Box>
      </Box>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    messageBody: state.formConfig.messageBody,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchUpdateFormConfig: bindActionCreators(updateFormConfig, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageBody);
